import React from 'react'
import PageHeader from '../Components/PageHeader'
import showToast from "../helpers/show_toast";
import { getSubmitForm } from "../helpers/forms_helper";
import { useEffect, useState } from 'react';
import Loader from '../Components/Loader';

const AboutUs = () => {
    const [allData, setAllData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetch_data();
    }, []);

    const fetch_data = async () => {
        setLoading(true)
        let url = "https://api.jmialumnivic.com.au/sliders/get_banner"
        let response = await getSubmitForm(url, "");
        if (response && response.status === 1) {
            setAllData(response.data);
            setLoading(false)
        } else {
            setLoading(false)
            showToast(response.error, "error")
        }
    };
    return (
        <>
            <section className='history_of_osa'>
                <div className="about_osa_layer">
                    <PageHeader heading="About Us" />
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="about_main_container">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {loading ?
                                                <div className='d-flex justify-content-center  text-center  py-5'>
                                                    <Loader/>
                                                </div>
                                                : allData && allData?.length > 0 ?
                                                    <div className="main_aboutimghere">
                                                        <img src={allData[0]?.about_banner_url} alt="about us" />
                                                    </div>
                                                    : ''}
                                        </div>
                                        <div className="col-md-12">
                                            <div className="aboutschool_text">

                                                <p>JMI Alumni Association of Victoria, Australia Incorporated is a registered body under Section 8 of Association Reform Act 2012. The Association was formally registered with Consumer Affairs Victoria on 21 May 2021.
                                                </p>
                                                <p>The Association is an enlightened, resourceful and dynamic group of individuals residing in the state of Victoria who share a common vision of promoting the values of our institution, Jamia Millia Islamia. Members of the Association dearly uphold the principles of universal education, sharing knowledge and skills, supporting and caring for each other, responding to the needs of the broader community with empathy and compassion; both at a local level as well as overseas, particularly during unforeseen and unfortunate circumstances affecting fellow humans in anyway. Association members fully embrace the spirit of giving back to the community in various capacities as well as promoting and preserving human rights globally.
                                                    <br />
                                                    The Association maintains a strong ongoing connection with Jamia Millia Islamia in New Delhi to exchange common interests and work on areas of mutual co-operation.
                                                    <br />
                                                    The members of the Association and their friends and families meet socially to celebrate various occasions and events creating an atmosphere of mutual trust and close friendship.
                                                    <br />
                                                    The Association aims to mobilize effective advocacy and leadership in the realization of a humane, respectful, fair and just society for all Victorians through awareness and education. Our aspiration is to contribute to the emergence of future leaders and role models for a better tomorrow to fulfil the dreams of our founders.
                                                    <br />
                                                    Let’s reflect for a moment on the words of Bharat Ratna recipient and the first education minister of independent India, Maulana Abul Kalam Azad, “Educationists should build the capacities of the spirit of inquiry, creativity, entrepreneurial and moral leadership among students and become their role model”.
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutUs
